module.exports = __webpack_public_path__ + "img/slide3.ad9adf20.png";